import { map, omit } from 'lodash';
import { useDispatch } from 'react-redux';

import generateId from 'src/lib/generateId';
import Thread, { IVR_TAGS, Node } from 'src/models/Thread/Thread';
import threadsResource from 'src/actions/threads/threadsResource';
import { translate } from '../helpers/translateValues';

export type ThreadWithNodeMap = Partial<Thread & { nodesMap: Record<string, Node> }>;

export default function useOnSave({ setComplete }) {
  const dispatch = useDispatch();

  return ({ add, isNew, resetErrors, validate, workingStateRef }) => {
    dispatch(resetErrors());

    let threadConfig = workingStateRef.current as ThreadWithNodeMap;

    const translatedConfig = translate<ThreadWithNodeMap>(threadConfig, { reverse: false });
    threadConfig = { tags: [IVR_TAGS.WISMO, IVR_TAGS.CONSUMER_SELF_SERVICE], ...translatedConfig };

    if (!dispatch(validate(threadConfig))) {
      return;
    }

    const nodes = map(threadConfig.nodesMap, node => node) as Node[];
    threadConfig = { ...omit(threadConfig, ['nodesMap', 'updatedAt', 'updatedBy']), nodes };

    setComplete(true);
    isNew
      ? dispatch(
          add({ ...threadConfig, id: generateId() }, { customToastMsg: `"${threadConfig.name}" has been created.` })
        )
      : dispatch(
          threadsResource.effects.createNewVersion(
            { id: workingStateRef.current.id, version: workingStateRef.current.version },
            threadConfig
          )
        );
  };
}
